// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/themes/dist/library/styles/reset.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/themes/dist/library/styles/fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/react-button/dist/library/styles/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/react-button-group/dist/library/styles/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/react-icons/dist/library/styles/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@usb-shield/react-modal/dist/library/styles/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modelBasic > div > div > div > h1 {
    font-family: "U.S. Bank Circular" !important;
}

.modelBasic > div > div > div {
    font-family: "U.S. Bank Circular" !important;
}

.modelTimer {
    font-size: 48px !important;
    font-weight: 500 !important;   
    color: #001E79 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "U.S. Bank Circular" !important;
    margin-bottom: 40px !important;
}

@media all and (max-width: 480px) {
    .usb-modal-v2--dialog {
        width: 288px !important;
        height: 390px !important;
    }

    .usb-modal-v2 .usb-modal-v2--container {
        border-radius: 8px !important;
    }

    .usb-modal-v2--body {
        overflow-y: hidden !important;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/sessionTimer/SessionTimerPopUp.css"],"names":[],"mappings":"AASA;IACI,4CAA4C;AAChD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4CAA4C;IAC5C,8BAA8B;AAClC;;AAEA;IACI;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;AAEJ","sourcesContent":["@import url('@usb-shield/themes/dist/library/styles/reset.css');\n@import url('@usb-shield/themes/dist/library/styles/fonts.css');\n\n@import url('@usb-shield/react-button/dist/library/styles/index.css');\n@import url('@usb-shield/react-button-group/dist/library/styles/index.css');\n@import url('@usb-shield/react-icons/dist/library/styles/index.css');\n\n@import url('@usb-shield/react-modal/dist/library/styles/index.css');\n\n.modelBasic > div > div > div > h1 {\n    font-family: \"U.S. Bank Circular\" !important;\n}\n\n.modelBasic > div > div > div {\n    font-family: \"U.S. Bank Circular\" !important;\n}\n\n.modelTimer {\n    font-size: 48px !important;\n    font-weight: 500 !important;   \n    color: #001E79 !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: \"U.S. Bank Circular\" !important;\n    margin-bottom: 40px !important;\n}\n\n@media all and (max-width: 480px) {\n    .usb-modal-v2--dialog {\n        width: 288px !important;\n        height: 390px !important;\n    }\n\n    .usb-modal-v2 .usb-modal-v2--container {\n        border-radius: 8px !important;\n    }\n\n    .usb-modal-v2--body {\n        overflow-y: hidden !important;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
